export const BREAK_ITEM_KEY = '{BREAK_ITEM}'
